<form [formGroup]="editarTarifaForm" (ngSubmit)="onSubmit()">
  <div>
    <label for="tarifa_por_hora">Tarifa por Hora</label>
    <input id="tarifa_por_hora" formControlName="tarifa_por_hora" type="number" step="0.01" />
    <div *ngIf="editarTarifaForm.get('tarifa_por_hora')?.invalid && editarTarifaForm.get('tarifa_por_hora')?.touched">
      <small class="error">Este campo es obligatorio y debe ser un número positivo</small>
    </div>
  </div>

  <div class="buttons-container">
    <button nz-button nzType="default" (click)="onCancel()">Cancelar</button>
    <button class="actualizar" nz-button nzType="primary" [disabled]="editarTarifaForm.invalid" htmlType="submit">Actualizar</button>
  </div>
</form>
